import { connect } from 'react-redux';
import 'dayjs/locale/es';
import 'moment/locale/es';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { getMySalesExecutiveDetails } from '_models/redux/my-sales-detail-executive/action';
import { getMySalesExecutive } from '_models/redux/reports-executive/action';
import { cleanMySalesAction } from '_models/redux/my-sales/clean-action';
import { Chart } from 'react-google-charts';
import { cleanMySalesExecutiveAction } from '_models/redux/reports-executive/clean';
import { useSalesExecutiveHook } from '../hooks/useSalesExecutiveHook';
import ExecutiveSalesList from './ExecutiveSalesList';
import FiltersSalesExecutive from './FiltersSalesExecutive';

const SalesDataTableExecutive = (props) => {
  const {
    isLoading,
    rows,
    open,
    options,
    dropdownValue,
    data,
    inputChange,
    handleMySalesDetails,
    displayDatepickers,
    startValue,
    setStartValue,
    setDropdownValue,
    setFromTime,
    handleClose,
    endValue,
    setEndValue,
    setToTime,
  } = useSalesExecutiveHook(props);

  const optionsGrid = {
    height: 500,
    annotations: { style: 'point' },
    legend: { position: 'bottom' },
    hAxis: { textPosition: 'out' },
  };

  return (
    <div>
      {isLoading ? (
        <div className='loader-container'>
          <CircularProgress size={80} />
        </div>
      ) : (
        <Grid container>
          <FiltersSalesExecutive
            dropdownValue={dropdownValue}
            inputChange={inputChange}
            options={options}
            displayDatepickers={displayDatepickers}
            setStartValue={setStartValue}
            startValue={startValue}
            setDropdownValue={setDropdownValue}
            setFromTime={setFromTime}
            endValue={endValue}
            setEndValue={setEndValue}
            setToTime={setToTime}
          />
          {data?.length > 1 ? (
            <Grid item size={{ xs: 12, md: 12 }}>
              <Chart
                chartType='LineChart'
                width='100%'
                height='auto'
                data={data}
                options={optionsGrid}
              />
            </Grid>
          ) : null}
          <ExecutiveSalesList
            handleMySalesDetails={handleMySalesDetails}
            handleClose={handleClose}
            rows={rows}
            open={open}
          />
        </Grid>
      )}
    </div>
  );
};

/******/
/** Redux map state to props **/
const mapStateToProps = (state) => ({
  mySalesExecutiveDetails: state?.mySalesExecutiveDetails,
  mySalesExecutive: state?.mySalesExecutive,
});

/** Redux map dispatch to props **/
const mapDispatchToProps = {
  cleanMySalesAction,
  getMySalesExecutive,
  cleanMySalesExecutiveAction,
  getMySalesExecutiveDetails,
};

/** Export component connected to redux **/
export default connect(mapStateToProps, mapDispatchToProps)(SalesDataTableExecutive);
